import LegalPage from './LegalPage';

export default function RefundPolicyPage() {
  return (
    <LegalPage
      title="환불 정책"
      mdPath="/legal/refund-policy.md"
    />
  );
}
